import type { Tag } from 'react-tag-input';

export const MAX_TAGS = 4;

type TagOption = { id: number; label: string; value: string };

export const addTagToList = (current: Tag[], item: TagOption, maxTags: number = MAX_TAGS): Tag[] => {
  const alreadyAdded = current.some((tag) => tag.text === item.label);
  if (alreadyAdded || current.length >= maxTags) return current;

  const newTag: Tag = {
    className: '',
    id: String(item.id),
    text: item.label,
  };
  return [...current, newTag];
};
